import { Dialog } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import CreateEntityModal from "src/createEntityModal/CreateEntityModal";
import { isRequesting } from "src/requestProgress/helpers";
import { actions } from "src/requestProgress/reducer";

import { showAlertBanner } from "src/shared/alertBanner/actions";
import { ALERT_BANNER_TYPES } from "src/shared/alertBanner/reducer";
import QuiqButton from "src/shared/QuiqButton";
import { resetUpload } from "../actions";
import CloseIcon from "../close.svg";
import UploadIcon from "../upload.svg";
import DocumentUploadForm from "./DocumentUploadForm";
import "./DocumentUploadModal.scss";

interface DocumentUploadModalState {
  isOpen: boolean;
  isCreateEntityModalOpen: boolean;
  uploadClicked: boolean;
}

interface DocumentUploadModalProps {
  resetUploadState: typeof resetUpload;
  showAlertBanner: typeof showAlertBanner;
  onOpen?: () => void;
  onClose?: () => void;
}

class DocumentUploadModal extends React.Component<
  DocumentUploadModalProps,
  DocumentUploadModalState
> {
  constructor(props: DocumentUploadModalProps) {
    super(props);
    this.state = {
      isOpen: false,
      isCreateEntityModalOpen: false,
      uploadClicked: false
    };
  }

  public onUploadButtonClick = () => {
    this.setState({ uploadClicked: true });
    this.props.resetUploadState();
    this.openModal();
  };

  public openModal = () => {
    if (this.props.onOpen) {
      this.props.onOpen();
    }

    this.setState({ isOpen: true });
  };

  public closeModal = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }

    this.setState({ isOpen: false });
  };

  public toggleCreateEntityModal = () => {
    this.setState(prevState => {
      return {
        isCreateEntityModalOpen: !prevState.isCreateEntityModalOpen
      };
    });
  };

  public onCreateEntityFinished = (isSuccess: boolean) => {
    const type = isSuccess
      ? ALERT_BANNER_TYPES.SUCCESS
      : ALERT_BANNER_TYPES.ERROR;
    const message = isSuccess
      ? "Success - New Entity Created"
      : "Error - Entity Already Exists";

    const options = {
      type,
      message
    };

    this.props.showAlertBanner(options);
    this.toggleCreateEntityModal();
  };

  public render() {
    return (
      <React.Fragment>
        <QuiqButton
          color="green"
          onClick={this.onUploadButtonClick}
          className="DocumentUploadModal__upload"
          isLoading={
            this.state.uploadClicked && isRequesting(actions.getMetadataConfig)
          }
        >
          <img src={UploadIcon} className="DocumentUploadModal__upload-icon" />
          Upload
        </QuiqButton>

        <CreateEntityModal
          toggleModal={this.toggleCreateEntityModal}
          isOpen={this.state.isCreateEntityModalOpen}
          isComingFromUploadScreen={true}
          onFinishedCallback={this.onCreateEntityFinished}
        />

        <Dialog
          open={this.state.isOpen && !isRequesting(actions.getMetadataConfig)}
          onClose={this.closeModal}
          className="DocumentUploadModal"
          PaperProps={{ className: "DocumentUploadModal__paper" }}
          transitionDuration={0}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          fullScreen={true}
          fullWidth={true}
        >
          <div
            className="DocumentUploadModal__close-icon-container"
            onClick={this.closeModal}
          >
            <img src={CloseIcon} className="DocumentUploadModal__close-icon" />
          </div>
          <div className="DocumentUploadModal__content">
            <DocumentUploadForm
              closeModal={this.closeModal}
              toggleCreateEntityModal={this.toggleCreateEntityModal}
            />
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default connect(
  null,
  {
    resetUploadState: resetUpload,
    showAlertBanner
  }
)(DocumentUploadModal);



// WEBPACK FOOTER //
// ./src/documentUpload/components/DocumentUploadModal.tsx